import React from 'react'

import ReactModal from '../ReactModal'
import { IMG } from '../../themes'
import { CRASH_MEETING_MODAL } from '../../helpers/constants'

import {
  StyleCrashMeetingModalHeader,
  StyleCrashMeetingModalContent,
  StyleCrashMeetingModalFooter,
} from './styles'

const CrashMeetingModal = (props) => {
  const {
    isVisible,
    language,
    colorTheme,
    onClose,
    onChangeDates,
    onConfirm,
  } = props

  return (
    <ReactModal isVisible={isVisible} width={420}>
      <StyleCrashMeetingModalHeader>
        <label className='crash-meeting-modal'>{CRASH_MEETING_MODAL.HEADER[language]}</label>
        <img
          className='pointer'
          src={IMG['close.svg']}
          onClick={onClose}
          alt='close'
        />
      </StyleCrashMeetingModalHeader>

      <StyleCrashMeetingModalContent>
        <label className='description'>{CRASH_MEETING_MODAL.DESCRIPTION[language]}</label>
      </StyleCrashMeetingModalContent>

      <StyleCrashMeetingModalFooter colorTheme={colorTheme}>
        <button
          className='change-date-button'
          onClick={onChangeDates}
        >
          {CRASH_MEETING_MODAL.CHANGE_DATE_BUTTON[language]}
        </button>

        <button
          className='confirm-button'
          onClick={onConfirm}
        >
          {CRASH_MEETING_MODAL.CONFIRM_BUTTON[language]}
        </button>
      </StyleCrashMeetingModalFooter>
    </ReactModal>
  )
}

export default CrashMeetingModal
